import React, { useState } from 'react';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';

const FeeAmountInput = ({ value, onChange, feeType, ccFlatFee, onFlatFeeChange, error = "" }) => {
  const [isTouched, setIsTouched] = useState(false); // Track if user modified the field

  const handleChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (!isNaN(newValue)) {
      onChange(newValue);
    } else if (event.target.value === '') {
      onChange(0);
    }
  };
  const handleFlatFeeChange = (event) => {
    setIsTouched(true); // Mark as touched on change

    const newValue = parseFloat(event.target.value);
    if (!isNaN(newValue)) {
      onFlatFeeChange(newValue);
    } else if (event.target.value === '') {
      onFlatFeeChange(0);
    }
  };

  return (
    <div className="d-flex justify-content-between gap-3">
      <Box style={{ flex: "1"}} sx={{ mb: 3 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 1 }}
        >
          Fee Amount
        </Typography>
        <TextField
          fullWidth
          value={value === 0 ? '' : value}
          onChange={handleChange}
          type="number"
          onWheel={(e)=>e.target.blur()}
          inputProps={{
            step: feeType === 'percentage' ? 0.01 : 0.1,
            min: 0,
            max: feeType === 'percentage' ? 100 : 999999,
          }}
          
          helperText={error}
          error={Boolean(error)}
          InputProps={{
            startAdornment: feeType === 'cash' ? (
              <InputAdornment position="start">$</InputAdornment>
            ) : (
              <InputAdornment position="start">%</InputAdornment>
            ),
            //   endAdornment: feeType === 'percentage' ? (
            //     <InputAdornment position="end">%</InputAdornment>
            //   ) : null,
            sx: {
              '& .MuiTypography-root': {
                fontWeight: 500,
                fontSize: "16px",
              },
              '& input': {
                textAlign: 'right',
                fontWeight: 500,
                fontSize: "14px",
                paddingRight: feeType === 'percentage' ? 2 : 2,
              },
            },
          }}
          variant="outlined"
          size="small"
          sx={{
            '& .MuiOutlinedInput-root': {
              transition: 'border-color 0.2s ease-in-out',
              '&:hover fieldset': {
                borderColor: 'primary.main',
              },
            },
          }}
        />
      </Box>
      {
        feeType === 'percentage' &&
        <Box style={{ flex: "1"}} sx={{ mb: 3 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1 }}
          >
            Flat Fee
          </Typography>

          <TextField
            fullWidth
            value={!isTouched && ccFlatFee === 0 ? "" : ccFlatFee?.toString() ?? ""}
            onChange={handleFlatFeeChange}
            type="number"
            onWheel={(e)=>e.target.blur()}
            inputProps={{
              step: feeType === "percentage" ? 0.01 : 0.1, // Allows 0.01 for %
              min: 0,
              max: feeType === "percentage" ? 100 : 999999,
            }}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              sx: {
                '& .MuiTypography-root': {
                  fontWeight: 500,
                  fontSize: "16px",
                },
                "& input": {
                  textAlign: "right",
                  fontWeight: 500,
                  fontSize: "14px",
                  paddingRight: feeType === "percentage" ? 2 : 2,
                },
              },
            }}
            variant="outlined"
            size="small"
          />


        </Box>
      }
    </div>
  );
};

export default FeeAmountInput;